module.exports = __webpack_public_path__ + "assets/img/bedroom_8-2.4c77937f.jpg";